<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="3">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">New list</h4>
          </template>
          <template v-slot:body>
            <FormulateForm
              name="createList"
              @submit="submitHandler"
              #default="{ isLoading }"
              v-model="formValues"
              data-cy="create-list-form"
            >
              <b-form>
                <b-form-group label="List name " label-for="name">
                  <FormulateInput
                    id="name"
                    name="name"
                    type="text"
                    validation="required"
                    input-class="form-control"
                    data-cy="name-input"
                  />
                </b-form-group>
              </b-form>
              <div class="d-flex justify-content-center">
                <b-button
                  block
                  type="submit"
                  variant="primary"
                  class="mb-3 mr-1"
                  data-cy="submit-button"
                  :disabled="isLoading"
                  :label="isLoading ? 'Loading...' : 'Submit this form'"
                  >Create list</b-button
                >
              </div>
            </FormulateForm>
          </template>
        </iq-card>
      </b-col>
      <!-- <b-col lg="6" offset-lg="3">
        <div
          class="iq-card-transparent iq-card-block iq-card-stretch iq-card-height"
        >
          <div class="iq-card-header text-center">
            <h4 class="card-title mb-4">Contacts in list (6)</h4>
          </div>
          <div class="iq-card-body p-0">
            <ul class="list-inline p-0 m-0">
              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>Joe</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Doe</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>joe.doe@email.com</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>+420 667 778 909</h6>
                </div>
              </li>
              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>Ivan</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Wagner</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>-</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>-</h6>
                </div>
              </li>
              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>Lisa</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Ann</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>lisa@lafficial.com</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>+31 667 543 123</h6>
                </div>
              </li>

              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>David</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Duckie</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>dducky@email.com</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>+12 556 787 666</h6>
                </div>
              </li>
              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>Laine</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Norton</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>norton@laine.com</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>+44 331 222 333</h6>
                </div>
              </li>
              <li class="d-flex mb-3 align-items-center p-3 bg-white rounded">
                <div class="media-support-info ml-3">
                  <h6>Dan</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>Brow</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>dannie@b.com</h6>
                </div>
                <div class="media-support-info ml-3">
                  <h6>+31 343 555 678</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </b-col>
      <b-col lg="6" offset-lg="3">
        <b-button block variant="primary" class="mb-3 mr-1">Save list</b-button>
      </b-col>-->
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
const CREATE_LIST = gql`
  mutation createList($name: String!) {
    insert_lists_one(object: { name: $name }) {
      id
      name
    }
  }
`;

export default {
  name: "ListsCreate",
  data() {
    return {
      formValues: {}
    };
  },
  methods: {
    async submitHandler() {
      try {
        const saveResponse = await this.$apollo.mutate({
          mutation: CREATE_LIST,
          variables: this.formValues
        });
        this.$toast.success(`List created`);
        this.$formulate.reset("createList");
        this.$router.push(
          `/lists/${saveResponse.data.insert_lists_one.id}/edit`
        );
      } catch (error) {
        this.$toast.error(`Failed to create list: ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
